// O que o navegador conta sobre si, no momento em que a pessoa clica.
//
// Serve ao alerta de login (`loginAlert.js`): a sessão é uma flag no
// localStorage e não existe backend de autenticação, então isto e o e-mail são
// tudo o que sobra para saber de onde veio quem entrou.
//
// Tudo é lido dentro de um `try`, campo a campo. Um `navigator` mutilado (modo
// privado, extensão que apaga propriedade, WebView antiga) não pode derrubar o
// alerta inteiro — perder uma linha da mensagem é barato, perder a mensagem
// não. Campo vazio nem chega a entrar: o `toStringMap` do `quartixApi` o
// descarta antes do POST.
//
// Só valores síncronos e de baixa entropia. `navigator.userAgentData` tem os
// dados bons (versão real do browser, modelo do aparelho) atrás do
// `getHighEntropyValues()`, que devolve uma Promise: esperar por ela atrasaria
// o alerta do press & hold, que é justamente o que se quer imediato.
export function collectClientInfo() {
  const info = {};
  const nav = typeof navigator !== "undefined" ? navigator : null;
  const win = typeof window !== "undefined" ? window : null;

  const put = (key, read) => {
    try {
      const value = read();
      if (value !== null && value !== undefined && value !== "") {
        info[key] = String(value);
      }
    } catch (e) {
      // Campo ausente, alerta preservado.
    }
  };

  if (!nav) return info;

  const uaData = nav.userAgentData;

  put("userAgent", () => nav.userAgent);
  // `navigator.platform` está depreciado e mente no iPadOS (diz "MacIntel"),
  // mas é o único que existe fora do Chromium; o `uaData` vem antes quando há.
  put("platform", () => (uaData && uaData.platform) || nav.platform);
  put("mobile", () => (uaData ? (uaData.mobile ? "yes" : "no") : ""));
  // As três primeiras bastam: a lista inteira é longa e a cauda não diz nada.
  put("language", () =>
    (nav.languages && nav.languages.length
      ? nav.languages.slice(0, 3)
      : [nav.language]
    ).join(", ")
  );
  put("screen", () => {
    const s = win && win.screen;
    if (!s) return "";
    const dpr = win.devicePixelRatio || 1;
    return `${s.width}x${s.height}` + (dpr !== 1 ? ` @${dpr}x` : "");
  });
  put("viewport", () => (win ? `${win.innerWidth}x${win.innerHeight}` : ""));
  put("timezone", () => Intl.DateTimeFormat().resolvedOptions().timeZone);
  // De onde veio o clique. Vazio em acesso direto — e aí some da mensagem.
  put("referrer", () => (typeof document !== "undefined" ? document.referrer : ""));

  return info;
}

export default collectClientInfo;
